import { Constructor } from "core-library/types/constructor";
import each from "lodash/each";
import get from "lodash/get";
import { Subject } from "rxjs";

export interface IDestroyable {
    onDestroy: Subject<void>;
    destroy(): void;
}

export const BaseDestroyableMixin = <TBaseClass extends Constructor<object>>(
    BaseClass: TBaseClass
): TBaseClass & Constructor<IDestroyable> => {
    return class BaseDestroyableExtension extends BaseClass implements IDestroyable {
        public onDestroy: Subject<void> = new Subject<void>();

        public destroy(): void {
            this.onDestroy.next();

            const properties = Object.getOwnPropertyDescriptors(this);

            each(properties, (propDescriptor: PropertyDescriptor, key: string) => {
                const value = get(this, key) as object;
                this.destroyMember(value);
            });
        }

        // It's necessary to override it because abstract mixin allow us do not implement abstract members in typescript.
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        protected destroyMember(value: object): void {
            throw new Error("Method not implemented.");
        }
    };
};
